import React, {useState} from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';
import {NeuroMessage, useDispatch, useUser, logout, useGuideConfig, buildPageUrl} from '../index.mjs';
import {ToggleMenu} from '../../neuro-ui';

const BranchMenu = ({children, className, hideDefaultOptions}) => {
  const componentClass = 'branchMenu';
  const [showMenu, setShowMenu] = useState(false);
  const dispatch = useDispatch();
  const { isBranchGuide } = useGuideConfig();
  const { getEmployee, getBranch, uuid } = useUser();
  const employee = getEmployee();
  const branch = getBranch();
  const classes = classnames(className, componentClass);

  const onLogoutClicked = () => dispatch(logout());

  const renderDefaultOptions = () => {
    const newConversationUrl = buildPageUrl({ type: 'newUser' });
    const startOverUrl = buildPageUrl({ uuid, type: 'landingWithUser' });
    return <ul className={`${componentClass}__options`}>
      <li><a href={startOverUrl}><i className="ion-md-refresh" /><NeuroMessage id="branchMenu.option.startOver" /></a></li>
      <li><a href={newConversationUrl}><i className="ion-md-contact" /><NeuroMessage id="branchMenu.option.newUser" /></a></li>
    </ul>;
  };

  return (
    isBranchGuide ? <React.Fragment>
      <button className={`${componentClass}__btn`} onClick={() => setShowMenu(true)}>
        <i className="ion-md-menu" />
      </button>

      <ToggleMenu className={classes} isOpen={showMenu} onOuterClick={() => setShowMenu(false)} animation="slideFromRight">
        <button className={`${componentClass}__closeBtn`} onClick={() => setShowMenu(false)}>
          <i className="ion-ios-close"/>
        </button>
        { employee ?
          <div className={`${componentClass}__employeeInfo`}>
            <NeuroMessage id={`${componentClass}.employeeInfoHeader`} tagName="span" />
            <h1>{ `${employee.firstName} ${employee.lastName}` }</h1>
            { branch ? <h3>{ branch.name }</h3> : null }
          </div> : null
        }
        { !hideDefaultOptions && renderDefaultOptions() }
        { children && <div className={`${componentClass}__children`}>{ children }</div> }
        <button onClick={onLogoutClicked} className={`${componentClass}__logout`}>
          <NeuroMessage id={`${componentClass}.logout`}/>
        </button>
      </ToggleMenu>
    </React.Fragment> : null
  );
};

BranchMenu.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  hideDefaultOptions: PropTypes.bool
};

export default BranchMenu;
